// Selling/stock units a part can carry (Part.unit). One list for every picker;
// the backend allowlist (inventory/services/package_content.PART_UNITS) and
// csv_import.VALID_UNITS mirror it.
export const UNIT_OPTIONS = ['kpl', 'l', 'ml', 'kg', 'g', 'm', 'cm', 'pkt', 'pari', 'sarja'];

// Package → content (1 tynnyri = 20 l): the per-content-unit price from the
// per-package price. Plain Number division rounded to 4 decimals, returned as
// a string for the DecimalField / payload. The lähete path never uses this
// (the server divides the row total); Smart Receive edits prices client-side
// already, so this is where its division has to live.
export function divideUnitPrice(price, factor) {
  const p = parseFloat(price);
  const f = parseFloat(factor);
  if (!Number.isFinite(p) || !Number.isFinite(f) || f <= 0) return '';
  return (Math.round((p / f) * 10000) / 10000).toString();
}
